import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import NavbarIconsVision from "../generic-nav-bar/NavbarIconsVision";
import FlowEngineSection from "../specialist-flow-engine/FlowEngineSection";
import useFormValidations from "../../app/hooks/useFormValidations";
import { useHydrateViewCatalogRelations } from "../../app/hooks/useHydrateViewCatalogRelations";
import { getObjectByCode } from "../../app/helpers/getObjectByCode";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { startLoadingCatalogCiiusAll } from "../../app/actions/catalogCiiuActions";
import { startLoadingCatalogSectionsAll } from "../../app/actions/catalogSectionActions";
import { startLoadingCatalogPhasesAll } from "../../app/actions/catalogPhaseActions";
import { startLoadingContinents } from "../../app/actions/continentActions";
import { startLoadingRegions } from "../../app/actions/regionActions";
import { startLoadingCountries } from "../../app/actions/countryActions";
import IntegrationViewChrome from "../end-user-search/IntegrationViewChrome";
import { useIntegrationNestedPreview } from "../end-user-search/integrationNestedPreviewContext";
import DetailSectionsLayout from "../end-user-search/DetailSectionsLayout";
import { getSectionHeader } from '../../app/helpers/helperValidationViewPreview';

const ViewVision = () => {
  debugLogPages(':: ViewVision');

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { nested } = useIntegrationNestedPreview();
  const isPreviewMode = false;

  /********Store*******/
  const { visionSelected } = useSelector((state) => state.vision);

  const { listFullCatalogCiius } =
    useSelector((state) => state.catalogCiiu);

  const { listFullCatalogSections } =
    useSelector((state) => state.catalogSection);

  const { listFullCatalogPhases } =
    useSelector((state) => state.catalogPhase);

  const { objectCountrySelectedInitial, objectRegionSelectedInitial, objectContinentSelectedInitial } = useSelector((state) => state.locationCountry);

  const { listFieldsVisionView, listFieldsVisionPreview } = useSelector((state) => state.moduleConfig);

  /********UseForm*******/
  const { values, handleChangeCatalogCiiu, handleChangeCatalogSection, handleChangeCatalogPhase, handleChangeLocation, setValues } = useFormValidations(
      () => VisionCallback(),
      visionSelected,
      listFieldsVisionView
    );

  const VisionCallback = () => {
    
  };

  useHydrateViewCatalogRelations('Vision', values, setValues);

  useEffect(() => {
    if (!nested) return undefined;
    dispatch(startLoadingCatalogCiiusAll());
    dispatch(startLoadingCatalogSectionsAll());
    dispatch(startLoadingCatalogPhasesAll());
    dispatch(startLoadingContinents());
    dispatch(startLoadingRegions());
    dispatch(startLoadingCountries());
    return undefined;
  }, [nested, dispatch]);

  useEffect(() => {
    
    if (values && values.catalogciius_id && listFullCatalogCiius) {
      let codigosCiius = values.catalogciiu_levels;

      let partes = codigosCiius.split(";");

      var objectCiiuFound = [];

      var currentCatalogCiiuLevelInValues = {
        1: values.catalogciiu_level1,
        2: values.catalogciiu_level2,
        3: values.catalogciiu_level3,
        4: values.catalogciiu_level4,
        5: values.catalogciiu_level5,
        6: values.catalogciiu_level6,
      };

      for (let i = 0; i < partes.length; i++) {

        objectCiiuFound[i] = getObjectByCode(partes[i], listFullCatalogCiius);
        
        handleChangeCatalogCiiu(objectCiiuFound[i], i + 1);

        currentCatalogCiiuLevelInValues[i + 1] = objectCiiuFound[i].id;
      }
    }

  }, [listFullCatalogCiius]);

  useEffect(() => {
    
    if (values && values.catalogsections_id && listFullCatalogSections) {
      let codigosSections = values.catalogsection_levels;

      let partes = codigosSections.split(";");

      var objectSectionFound = [];

      var currentCatalogSectionLevelInValues = {
        1: values.catalogsection_level1,
        2: values.catalogsection_level2,
        3: values.catalogsection_level3,
        
      };

      for (let i = 0; i < partes.length; i++) {
        
        objectSectionFound[i] = getObjectByCode(partes[i], listFullCatalogSections);
        
        handleChangeCatalogSection(objectSectionFound[i], i + 1);

        currentCatalogSectionLevelInValues[i + 1] = objectSectionFound[i].id;
      }
    }

  }, [listFullCatalogSections]);

    useEffect(() => {
      
      if (values && values.catalogphases_id && listFullCatalogPhases) {
        let codigosPhases = values.catalogphase_levels;

        let partes = codigosPhases.split(";");

        var objectPhaseFound = [];
  
        var currentCatalogPhaseLevelInValues = {
          1: values.catalogphase_level1,
          2: values.catalogphase_level2,
          3: values.catalogphase_level3,
          4: values.catalogphase_level4
        };

        for (let i = 0; i < partes.length; i++) {
          objectPhaseFound[i] = getObjectByCode(partes[i], listFullCatalogPhases);
          
          handleChangeCatalogPhase(objectPhaseFound[i], i + 1);
  
          currentCatalogPhaseLevelInValues[i + 1] = objectPhaseFound[i].id;
        }
      }
  
    }, [listFullCatalogPhases]);

  useEffect(() => {
    for (let i = 0; i < 3; i++) {

      if (i === 0 && objectContinentSelectedInitial && objectContinentSelectedInitial?.id !== "undefined" && objectContinentSelectedInitial?.id > 0) {
        handleChangeLocation(objectContinentSelectedInitial, "catalogcontinents_id");
        
      }
      if (i === 1 && objectRegionSelectedInitial && objectRegionSelectedInitial?.id !== "undefined" && objectRegionSelectedInitial?.id > 0) {
        handleChangeLocation(objectRegionSelectedInitial, "catalogregions_id");
        
      }
      if (i === 2 && objectCountrySelectedInitial && objectCountrySelectedInitial?.id !== "undefined" && objectCountrySelectedInitial?.id > 0) {
        
        handleChangeLocation(objectCountrySelectedInitial, "catalogcountries_id");
        
      }
    }
  }, [objectContinentSelectedInitial, objectRegionSelectedInitial, objectCountrySelectedInitial]);


  const { arrayListPrincipal, arrayListSecondary } = listFieldsVisionPreview;

  // 1. Definimos las llaves relacionales específicas para Visiones
  const visionViewRelations = {
    multimedia: "ModuleFile_To_Vision",
    problems: "ModProblem_To_Vision" // Clave relacional de problemas si aplicara
  };

  // 2. Propiedades unificadas para inyectar en el motor genérico
  const sharedViewProps = {
    values,
    t,
    ProblemTableComponent: null, // No se detecta ninguna tabla de problemas activa en este módulo
    relationKeys: visionViewRelations,
    isPreviewMode // nested preview ↔ view toggle; normal route = full view
  };

  const principalHeader = getSectionHeader(arrayListPrincipal);
  const secondaryHeader = getSectionHeader(arrayListSecondary);

  return (
    <div>
      {!nested && <NavbarIconsVision page={"viewText"} />}

      {!nested && (
        <IntegrationViewChrome
          sourceModuleKey="vision"
          record={visionSelected}
        />
      )}

      {!nested && (
        <>
          <div className="d-flex justify-content-center page-title">
            {t("vision.view.title")}
          </div>
          <hr className="line-hr" />
        </>
      )}
      <div className="section is-fullheight">
        <div className="container">
          <form>
            <div className="container-fluid">
              <DetailSectionsLayout
                nested={nested}
                isPreviewMode={isPreviewMode}
                arrayListPrincipal={arrayListPrincipal}
                arrayListSecondary={arrayListSecondary}
                principalHeader={principalHeader}
                secondaryHeader={secondaryHeader}
                sharedViewProps={sharedViewProps}
              />
            </div>

            <FlowEngineSection
              record={visionSelected}
              moduleProcess="vision"
              moduleName={t("vision.view.title")}
              onAfterAction={() => {}}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default ViewVision;
